<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'ペアリング/接続する'">
          <list-item :spanText="'Q. '" :text="'WeBand3SCのリセット(接続QRコードの再表示)'" :urlName="'Help31'"></list-item>
          <list-item :spanText="'Q. '" :text="'利用中にペアリングが切れた場合'" :urlName="'Help23'"></list-item>
          <list-item :spanText="'Q. '" :text="'WeBandをペアリングできない'" :urlName="'Help9'"></list-item>
          <list-item :spanText="'Q. '" :text="'開封後ペアリングができない'" :urlName="'Help29'"></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory33.vue